  // import { useGetAllCategory } from "hooks/useCategory";
  import styled from "@emotion/styled";
  import { DatePicker, Form, Input, Select, Spin, Switch } from "antd";
  import React, { FC, useEffect, useState } from "react";
  import { useGetProductList } from "hooks/useProduct";
  import CampaignWysiwyg from "./CampaignWysiwyg";
  import { Box } from "@mui/material";
  import { Image } from 'antd';
import { DataResponseNewsProductList } from "services/interface/news/news.interface";

  interface CampaignDescriptionFormProps {
    is_active: boolean;
    setCheckIsActive: (checkIsActive: boolean) => void;
    content: string;
    setContent: (content: string) => void;
    start_date?: any,
    end_date?: any,
    productList?: DataResponseNewsProductList[]
  }

  const { Option } = Select;

  const CampaignDescriptionForm: FC<CampaignDescriptionFormProps> = ({ is_active, setCheckIsActive, content, setContent, start_date, end_date, productList }) => {
    const {
      data: ProductListActive,
      isLoading: loadingProductListActive,
      // refetch: refectchProductListActive,
    } = useGetProductList({ is_active: true, is_approve: true });

    // console.log(productList)

    const [startValue, setStartValue] = useState<any>(null);
    const [endValue, setEndValue] = useState<any>(null);
  
    
    const handleStartDateChange = (date: any) => {
      setStartValue(date);
    };
  
    const handleEndDateChange = (date: any) => {
      setEndValue(date);
    };
  
    const disabledEndDate = (current: any) => {
      return current < startValue;
    };
  
    const disabledStartDate = (current: any) => {
      if (!startValue || !current) {
        return false;
      }
      return current > endValue;
    };

    const handleContentChange = (text: string) => {
      setContent(text)
    };

    useEffect(() => {
      if (start_date && end_date) {
        setStartValue(start_date);
        setEndValue(end_date);
      }
    }, [start_date, end_date]);

    const children: React.ReactNode[] = []
    ProductListActive?.products?.forEach(item => {
      children.push(
        <Option key={item.id} value={item.id}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {' '}
            <Image src={item.image_url} height={35} width={35} />
            {item.name}
          </Box>
        </Option>
      )
    })

    const productListChildren: React.ReactNode[] = []
    productList?.forEach(item => {
      productListChildren.push(
        <Option key={item.id} value={item.id}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {' '}
            <Image src={item.image} height={35} width={35} />
            {item.name}
          </Box>
        </Option>
      )
    })

    
    return (
    <>
    <FormWrapper>
      <Form.Item
      label="สถานะการมองเห็น"
      name="is_active"
      valuePropName="checked"
      rules={[{ required: false, message: "กรุณากรอกชื่อสินค้า" }]}
      >
      <Switch
        onChange={(value) => {
        setCheckIsActive(value);
      }}
      />
      </Form.Item>
      <Form.Item
        label="ปักหมุด"
        name="is_ads"
        valuePropName="checked"
        rules={[{ required: false , message: "กรุณาเลือก ads" }]}
      >
        <Switch 
          // onChange={(value) => {
          //   setCheckIsActive(value);
          // }}
        />
      </Form.Item>
      <Form.Item
        label="วันที่เริ่มต้น"
        name="start_date"
        required
        rules={[{ required: true, message: "กรุณากรอกวันที่เริ่มต้น" }]}
      >
        <DatePicker 
            value={startValue}
            onChange={handleStartDateChange}
            placeholder="Start Date"
            format={"YYYY-MM-DD"}
            disabledDate={disabledStartDate}
        />
      </Form.Item>
      <Form.Item
        label="วันที่สิ้นสุด"
        name="end_date"
        required
        rules={[{ required: true, message: "กรุณากรอกวันที่สิ้นสุด" }]}
      >
        <DatePicker
          value={endValue}
          onChange={handleEndDateChange}
          placeholder="End Date"
          format={"YYYY-MM-DD"}
          disabledDate={disabledEndDate}
        />
      </Form.Item>
      <Form.Item
        label="ประเภทข่าวสารและโปรโมชั่น"
        name="new_type"
        required
        rules={[{ required: true, message: "กรุณากรอกประเภทข่าวสารและโปรโมชั่น" }]}
      >
        <Select
          // showSearch
          placeholder="กรุณาเลือกประเภท"
          optionFilterProp="children"
          options={[
            {
              value: 'news',
              label: 'ข่าวสาร',
            },
            {
              value: 'promotion',
              label: 'โปรโมชั่น',
            }
          ]}
        />
      </Form.Item>

      <Form.Item
        label="หัวข้อข่าวสารและโปรโมชั่น"
        name="topic"
        required
        rules={[{ required: true, message: "กรุณากรอกหัวข้อข่าวสารและโปรโมชั่น" }]}
      >
        <Input
          placeholder="กรุณากรอกหัวข้อข่าวสารและโปรโมชั่น"
          showCount
          maxLength={120}
          size="small"
          autoComplete="off"
        />
      </Form.Item>
      <Form.Item
        label="เนื้อหา"
        name="content"
        rules={[{ message: "กรุณากรอกเนื้อหา" }]} //required: is_active,
      >
      <CampaignWysiwyg content={content} onContentChange={handleContentChange}></CampaignWysiwyg>
      </Form.Item>
      <Form.Item
        label="ลิงค์วิดีโอ"
        name="video_url"
        rules={[
          { required: false, message: "กรุณากรอกลิงค์วิดีโอ" },
          {
            validator(rule, value) {
              if (!value || value.startsWith("https://")) {
                return Promise.resolve();
              }
              return Promise.reject("ลิงค์วีดีโอต้องขึ้นต้นด้วย 'https://'");
            },
          },]}
        
        >
          <Input
            placeholder="กรุณากรอกลิงค์วิดีโอ"
            showCount
            maxLength={300}
            size="small"
            autoComplete="off"
          />
        </Form.Item>
        <Form.Item
          label="สินค้าที่เกี่ยวข้อง"
          name="productId"
          rules={[{ required: false, message: "กรุณาเลือกสินค้าที่เกี่ยวข้อง" }]}
          // initialValue={productListChildren}
        >
          <Select
            mode="multiple"
            style={{
              width: '100%',
            }}
            // defaultValue={productListChildren}
            placeholder="สินค้าที่เกี่ยวข้อง"
            optionFilterProp="children"
            notFoundContent={loadingProductListActive ? <Spin size="small" /> : null}
            loading={loadingProductListActive}
          >
            {/* {productListChildren} */}
            {children}
          </Select>
        </Form.Item>
      </FormWrapper>
    </>
    );
  };

  export default CampaignDescriptionForm;

  const FormWrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    padding: 20px 20px 2px 20px;
    border-radius: 8px;
  `;
